import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "c-dev-example" }
const _hoisted_2 = {
  key: 0,
  class: "c-title"
}
const _hoisted_3 = { class: "c-description" }
const _hoisted_4 = { class: "c-inner-content" }

import { ref } from 'vue';

interface Props {
  title?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DevExample',
  props: {
    title: {}
  },
  emits: ["click-description"],
  setup(__props: any, { expose: __expose, emit: __emit }) {



const emit = __emit;

const counter = ref(0);

function onClickDescription(ev: Event) {
  counter.value++;

  emit('click-description', counter.value, ev);
}

__expose({
  counter,
  testExpose: {
    message: 'Просто пример экспортируемого значения из компонента'
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (__props.title)
      ? (_openBlock(), _createElementBlock("h3", _hoisted_2, _toDisplayString(__props.title), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("p", _hoisted_3, [
      _cache[0] || (_cache[0] = _createTextVNode(" Это тестовый Vue компонент! ", -1 /* CACHED */)),
      _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1 /* CACHED */)),
      _cache[2] || (_cache[2] = _createTextVNode(" Предназначен, для проверки работы компонента внутри Angular окружения ", -1 /* CACHED */)),
      _createElementVNode("button", {
        type: "button",
        onClick: _withModifiers(onClickDescription, ["prevent"])
      }, " Кликов - " + _toDisplayString(counter.value), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _cache[3] || (_cache[3] = _createTextVNode(" Компонент, без вложенного контента ", -1 /* CACHED */))
      ])
    ])
  ]))
}
}

})